import {createAction} from "redux-act";
import type {
	ICreateLeague,
	IDeleteLeague,
	IJoinToLeaguesResponse,
	ILeague,
	IMyLeaguesResponse,
	IUpdateLeague,
} from "modules/types/leagues";

export const createLeague = createAction<ICreateLeague>();
export const createLeagueSuccess = createAction<ILeague>();
export const createLeagueFailed = createAction<Error>();
export const clearCurrenLeague = createAction();
export const clearCurrenLeagueError = createAction();

export const updateLeague = createAction<IUpdateLeague>();
export const updateLeagueSuccess = createAction<ILeague>();
export const updateLeagueFailed = createAction<Error>();

export const deleteLeague = createAction<IDeleteLeague>();
export const deleteLeagueSuccess = createAction();
export const deleteLeagueFailed = createAction<Error>();

export const leaveLeague = createAction<IDeleteLeague>();
export const leaveLeagueSuccess = createAction();
export const leaveLeagueFailed = createAction<Error>();

interface IFetchMyLeaguesRequest {
	limit: number;
	page: number;
	search: string;
	privacy: string;
}

export const fetchMyLeagues = createAction<Partial<IFetchMyLeaguesRequest>>();
export const fetchMyLeaguesSuccess = createAction<IMyLeaguesResponse>();
export const fetchMyLeaguesFailed = createAction<Error>();
export const clearMyLeaguesList = createAction();

interface IFetchLeaguesToJoin {
	limit: number;
	page: number;
	search: string | null;
	showJoined: number;
}

export const fetchLeaguesToJoin = createAction<IFetchLeaguesToJoin>();
export const fetchLeaguesToJoinSuccess = createAction<IJoinToLeaguesResponse>();
export const fetchLeaguesToJoinFailed = createAction();
export const clearJoinLeaguesList = createAction();

interface IJoinToLeague {
	leagueCode: string;
	onSuccess?: () => void;
	onError?: () => void;
}

export const joinToLeague = createAction<IJoinToLeague>();
export const joinToLeagueSuccess = createAction<ILeague>();
export const joinToLeagueFailed = createAction();

interface IFetchLeague {
	id: number;
}

export const fetchLeagueById = createAction<IFetchLeague>();
export const fetchLeagueByIdSuccess = createAction<ILeague>();
export const fetchLeagueByIdFailed = createAction();

interface ILeagueUsersPayload {
	leagueId: number;
	limit?: number | null;
	page?: number | null;
	search?: string | null;
}
export interface ILeagueUser {
	id: number;
	username: string;
	avatar: string | null;
	level: number | null;
	levelName: string | null;
	levelColor: string | null;
}
interface ILeagueUsersResponse {
	users: ILeagueUser[];
	nextPage: boolean;
}

export const fetchLeagueUsers = createAction<ILeagueUsersPayload>();
export const fetchLeagueUsersSuccess = createAction<ILeagueUsersResponse>();
export const fetchLeagueUsersFailed = createAction<Error>();

export const clearLeagueUsers = createAction();

interface IRemoveUserPayload {
	userId: number;
	leagueId: number;
}

export const removeLeagueUser = createAction<IRemoveUserPayload>();
export const removeLeagueUserSuccess = createAction<Pick<IRemoveUserPayload, "userId">>();
export const removeLeagueUserFailed = createAction<Error>();
